export default __webpack_public_path__ + "static/media/Mindfulness-Podcast.9f6e5a5a.png";